import { StoreOfferProduct } from '@common'

import { BrawlerHero } from './BrawlerHero'
import { RegularHero } from './RegularHero'

type Props = {
  product: StoreOfferProduct
}

function isBrawlerOffer(product: StoreOfferProduct) {
  const isBrawlStars = product.game === 'brawlstars'
  const isItemTypeHero = product.contents.some((c) => c.product.itemType === 'Hero')
  return isBrawlStars && isItemTypeHero
}

export const Hero = ({ product }: Props) => {
  if (isBrawlerOffer(product)) {
    return <BrawlerHero product={product} />
  }

  return <RegularHero product={product} />
}
